export enum GitHubAPIEnum {
  url = 'https://api.github.com',
  user = 'the-glima',
  perPage = 60,
  gistTechLogosId = 'cba6af25cf3143ff16de5b4f4d06c87d'
}
